import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ svc, index, prefix = "service-card" }) {
  return (
    <Link
      to={`/services/${svc.slug}`}
      data-testid={`${prefix}-${svc.slug}`}
      className="block h-full group"
    >
      <div className="spotlight corner-card bg-card border border-white/10 h-full p-6 hover:border-amber/60 transition-colors duration-300">
        <div className="font-mono text-[10px] text-amber tracking-widest">
          {String(index + 1).padStart(2, "0")}
        </div>
        <h3 className="mt-3 font-display font-bold uppercase tracking-wide text-xl text-white leading-tight group-hover:text-amber transition-colors duration-300">
          {svc.title}
        </h3>
        <p className="mt-3 text-xs sm:text-sm text-gray-400 leading-relaxed">
          {svc.tagline}
        </p>
        <div className="mt-4 flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-amber">
          Intel <ArrowRight className="w-3 h-3 transition-transform duration-300 group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
}
